import { useState } from "react";
import PanchangFrame from "../../Assests/PanchangFrame.png";
import DOMPurify from "dompurify";
import { retrieveData } from "../../LocalConnection/LocalConnection";
export default function ChartSection({ data_chart, data_list, title }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const savedChartType_check = retrieveData("selectedChartType");
  const savedChartType =
    savedChartType_check !== "" ? savedChartType_check : "north";

  return (
    <>
      {/**---------------North Chart-------- */}
      {data_chart && data_chart.length > 0 && (
        <>
          {savedChartType === "north" && (
            <div className="flex flex-col justify-center items-center ">
              <h3 className="w-fit text-[16px] pb-[0.4rem] mb-[1rem] border-b-2 border-b-[#f5992a]">
                {title}
              </h3>
              <div className="chart_Main_div relative w-[480px] max-h-[400px]">
                <img
                  src={PanchangFrame}
                  alt="Kundali Frame"
                  className="w-full h-full"
                  onLoad={() => setImageLoaded(true)}
                />

                {imageLoaded &&
                  data_chart.map((house, index) => (
                    <div
                      key={index}
                      className={`absolute house${house.index_no}`}
                    >
                      <div className="flex flex-col justify-center items-center">
                        <p className="text-[var(--black)] text-[15px] mb-[3px]">
                          {house.chart_interger_no}
                        </p>
                        <label className="text-[12px] flex gap-1 items-start mt-[-2px]">
                          <span
                            style={{
                              width: "92px",
                              height: "60px",
                              overflowWrap: "break-word",
                              fontSize: "14px",
                              whiteSpace: "normal",
                              overflowX: "scroll",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                house.chart_interger_name
                              ),
                            }}
                          ></span>
                          
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {/* --------------- South Indian Chart with Data --------------- */}
          {savedChartType === "south" && (
            <div className="flex flex-col justify-center items-center ">
              <h3 className="w-fit text-[16px] pb-[0.4rem] mb-[1rem] border-b-2 border-b-[#f5992a]">
                {title}
              </h3>
              <div class="kundli-diamond">
                <div className="kundli-grid-north">
                  {data_chart.map((house, index) => (
                    <div
                      key={index}
                      className={`kundli-box-north house${house.index_no} ${
                        parseInt(house.index_no) === 1 ? "ascendant-north" : ""
                      }`}
                    >
                      <div className="box-content-north">
                        <p className="text-[var(--black)] text-[15px] mb-[3px]">
                          {house.chart_interger_no}
                        </p>
                        <span
                          style={{ width: "70px", fontSize: "14px" }}
                          className="planet"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              house.chart_interger_name
                            ),
                          }}
                        ></span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {data_list !== null && (
        <>
          <div className="px-0 flex flex-wrap justify-center items-center mt-3 md:mt-5 gap-2 md:gap-4">
            <p className="text-[var(--light-pink-color)] text-[13px] flex items-center gap-1">
              (
              <span className="inline-flex items-center justify-center h-full">
                *
              </span>
              ) Restrograde
            </p>
            <p className="text-[var(--light-pink-color)] text-[13px] flex items-center gap-1">
              (
              <span className="inline-flex items-center justify-center h-full">
                ^
              </span>
              ) Combust
            </p>
            <p className="text-[var(--light-pink-color)] text-[13px] flex items-center gap-1">
              (
              <span className="inline-flex items-center justify-center h-full">
                ↓
              </span>
              ) Debilitated
            </p>
            <p className="text-[var(--light-pink-color)] text-[13px] flex items-center gap-1">
              (
              <span className="inline-flex items-center justify-center h-full">
                □
              </span>
              ) Vargottama
            </p>
            <p className="text-[var(--light-pink-color)] text-[13px] flex items-center gap-1">
              (
              <span className="inline-flex items-center justify-center h-full">
                ↑
              </span>
              ) Exalted
            </p>
          </div>

          <div className="mt-[2rem] bg-white p-6 rounded-xl shadow-md w-full max-w-5xl overflow-x-auto">
            {data_list.length === 0 ? (
              <p className="text-center text-purple-400 py-10">
                No data found.
              </p>
            ) : (
              <table className="w-full text-sm text-left text-gray-800 bg-white border-collapse  overflow-x-auto rounded-md">
                <thead>
                  {data_list
                    .filter((_, index) => index === 0)
                    .map((item, index) => (
                      <tr
                        key={index}
                        className="text-purple-700 border-b border-gray-300"
                      >
                        <th className="py-3 px-2 pr-4 text-center">
                          {item.planet}
                        </th>
                        <th className="py-3 px-2 pr-4 text-center">
                          {item.sign}
                        </th>
                        <th className="py-3 px-2 pr-4 text-center">
                          {item.degree}
                        </th>
                        <th className="py-3 px-2 pr-4 text-center">
                          {item.naks}
                        </th>
                        <th className="py-3 px-2 pr-4 text-center">
                          {item.rel}
                        </th>
                      </tr>
                    ))}
                </thead>
                <tbody>
                  {data_list
                    .filter((_, index) => index !== 0)
                    .map((item, index) => (
                      <tr
                        key={index}
                        className={`${
                          index % 2 === 0 ? "bg-gray-100" : "bg-gray-50"
                        } hover:bg-purple-100 transition-all duration-200 border-b border-gray-300`}
                      >
                        <td className="py-3 px-2 pr-4 text-center">
                          {item.planet}
                        </td>
                        <td className="py-3 px-2 pr-4 text-center">
                          {item.sign}
                        </td>
                        <td className="py-3 px-2 pr-4 text-center">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(item.degree),
                            }}
                          ></span>
                        </td>
                        <td className="py-3 px-2 pr-4 text-center">
                          {item.naks}
                        </td>
                        <td className="py-3 px-2 pr-4 text-center">
                          {item.rel}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </>
  );
}
